import React from "react";
import classNames from "classnames";
import { getDefaultImageText } from "./utility";

interface MessageSenderImageProps {
   imageUrl?: string | undefined;
   isSpaceExpert?: boolean;
   name?: string;
   className?: string | undefined;
}

const MessageSenderImage: React.FC<MessageSenderImageProps> = ({ isSpaceExpert, imageUrl, name, className }) => {
   return <div className={classNames(className, "message-sender-image", { "message-sender-image--space-expert": isSpaceExpert })}>
      {
         imageUrl
            ? <img src={imageUrl} alt={name} />
            : getDefaultImageText(name)
      }
   </div>
};

export default MessageSenderImage;